import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';

const RoomManagementTab = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ padding: "40px 20px", textAlign: "center" }}>
      <Typography sx={{ fontSize: "16px", color: "#999" }}>
        {t("ComingSoon")}
      </Typography>
    </Box>
  );
};

export default RoomManagementTab;
